import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/data/siteData";

export const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <nav
      data-testid="navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-slate-200/50 shadow-sm"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link
            to="/"
            data-testid="nav-logo"
            className="flex items-center gap-2 group"
            onClick={() => setMobileOpen(false)}
          >
            <img
              src="https://coffice24x7.in/assets/img/front-page-img/coffice_logo.svg"
              alt="Coffice 24x7"
              className="h-9 w-auto"
            />
          </Link>

          {/* Desktop Links */}
          <div className="hidden md:flex items-center gap-8">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                data-testid={`nav-${link.label.toLowerCase()}-link`}
                className={`text-sm font-medium transition-colors ${
                  location.pathname === link.href
                    ? "text-orange-500"
                    : "text-slate-600 hover:text-orange-500"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:block">
            <Link
              to="/contact"
              data-testid="nav-cta-button"
              className="rounded-full bg-orange-500 text-white font-medium px-5 py-2.5 text-sm hover:bg-orange-600 active:scale-95 transition-all shadow-md shadow-orange-500/20"
            >
              Book a Visit
            </Link>
          </div>

          {/* Mobile Toggle */}
          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden p-2 text-slate-600 hover:text-slate-900"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-slate-200/50 bg-white/95 backdrop-blur-xl animate-fade-in"
        >
          <div className="px-4 py-4 space-y-1">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                data-testid={`nav-mobile-${link.label.toLowerCase()}-link`}
                className={`block px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.href
                    ? "bg-orange-50 text-orange-500"
                    : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                }`}
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-2">
              <Link
                to="/contact"
                data-testid="nav-mobile-cta-button"
                className="block text-center rounded-full bg-orange-500 text-white font-medium px-5 py-2.5 text-sm hover:bg-orange-600 transition-all"
                onClick={() => setMobileOpen(false)}
              >
                Book a Visit
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};
